<template>
  <div id="top-box">
    <div class="container">
      <div class="pull-left">
          <h5 v-if="isMobile()" style="color:#f99c6d;rgba(0,0,0,0.6);margin-right:10px;margin-top:10px;font-weight:normal;font-size:16px;font-family: 'Arimo', sans-serif;" class="title">Girish Jewellers</h5>
      </div>
      <div id="topRighLink" v-if="!isMobile()" class="my-account navbar navbar-inverse pull-right">
        <div class="navbar-inner">
      <nav>
          <ul class="nav">
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/contact">Contact Us</router-link></li>
          <li v-if="Session.is_login"><router-link to="/account">Account</router-link></li>
          <li v-if="!Session.is_login"><router-link to="/create-account">Sign up</router-link></li>
          <li v-if="!Session.is_login"><router-link to="/login">Log in</router-link></li>
          <li v-if="Session.is_login"><a v-on:click="Logout" href="javascript:void();">Logout</a></li>
          </ul>
      </nav>
        </div>
      </div><!-- .my-account -->
    </div>
  </div><!-- #top-box -->
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
//import func from '../../vue-temp/vue-editor-bridge';
//import EventBus from '@/EventBus.js'
//import Authentication from '@/authentication.js';
//import $ from 'jquery';

export default {
  name: 'TopHeader',
  props: {
    msg: String
  },data:function(){

      return {results: {session:{}} };

  },
  computed:mapGetters(["Session"]),
  watch:{
    Session(newValue) {this.results.session = newValue;},
    DeliveryAddress(newValue) {this.get_delivery_response(newValue);}
  }
  ,mounted: function() {
      this.getSession();
      this.results.session = this.$store.getters.Session;
      
  },
  methods:{
    ...mapActions(["logoutSession","getSession"]),
  isMobile:function(){
     return Common.isMobile();
   },
    Logout:function()
    {
            this.logoutSession();
            this.$router.push("/login");
    }
  }
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

